import { cn } from "../../utils";

export type PartnerKey = "ninjatrader" | "kinetick";

const PARTNER_URLS: Record<PartnerKey, string> = {
  ninjatrader: "https://ninjatraderdomesticvendor.sjv.io/MKR3vY",
  kinetick: "http://kinetick.com/NinjaTrader",
};

// Display names for the accessible image alt fallback (correct brand casing).
const PARTNER_NAMES: Record<PartnerKey, string> = {
  ninjatrader: "NinjaTrader",
  kinetick: "Kinetick",
};

type PartnerLogoProps = {
  partner: PartnerKey;
  /** Logo image source (imported asset or URL). */
  src: string;
  alt?: string;
  /** Classes on the wrapping anchor (positioning / negative margins). */
  className?: string;
  /** Classes on the <img> itself (sizing, e.g. "h-6 w-auto"). */
  imgClassName?: string;
};

/**
 * NinjaTrader Vendor Program — partner logo with mandatory clear-space.
 *
 * Enforces a minimum 18px clear-space on all sides of the logo and links to the
 * exact tracked partner URL. Inline padding guarantees the 18px regardless of
 * Tailwind purge.
 */
export default function PartnerLogo({
  partner,
  src,
  alt,
  className,
  imgClassName,
}: PartnerLogoProps) {
  return (
    <a
      href={PARTNER_URLS[partner]}
      target="_blank"
      rel="noopener noreferrer"
      className={cn("inline-flex items-center justify-center", className)}
      style={{ padding: 18 }}
    >
      <img src={src} alt={alt ?? PARTNER_NAMES[partner]} className={imgClassName} />
    </a>
  );
}
